/* eslint-disable */

/**
 * @file
 * A JavaScript file containing the share block functions.
 *
 */

(function ($, Drupal, drupalSettings) {
  'use strict';

  $('.share-whatsapp-link').attr('href', function () {
    return 'whatsapp:' + $(this).attr('href');
  });

  $('.share-clipboard-link').on('click', function (event) {
    event.preventDefault();
    window.navigator.clipboard.writeText(window.location.href);
  });

})(jQuery, Drupal, drupalSettings);
